import React, { JSX, memo } from 'react';
import { Module, ModuleProps } from '../components/Module';
import { moduleConfigFactory } from './moduleConfigFactory';

/**
 * Create a memo'd Module (with props) ready to be used.
 * @example
 * const NavCanvas = moduleMemoFactory<{ tradingRoutePrefix: string }>({
 *   module: moduleConfigFactory('webinvest-module-navigation', './NavCanvas')
 * });
 * ...
 * <NavCanvas tradingRoutePrefix='thePrefix' />
 * @example
 * const NavCanvas = moduleMemoFactory<{ tradingRoutePrefix: string }>({
 *   appName: 'webinvest-module-navigation', moduleName: './NavCanvas'
 * });
 * ...
 * <NavCanvas tradingRoutePrefix='thePrefix' />
 * @param param0
 * @returns
 */
export const moduleMemoFactory = <TModuleProps,>({
  appName,
  moduleName,
  module,
  log = () => {},
  error = () => {}
}: { appName?: string; moduleName?: string } & Partial<Omit<ModuleProps, 'moduleProps'>>) => {
  const theModule = module ?? moduleConfigFactory(appName!, moduleName!);
  /* eslint-disable react/display-name */
  return memo(({ loadingElement, ...moduleProps }: TModuleProps & { loadingElement?: JSX.Element }) => (
    <Module module={theModule} log={log} error={error} moduleProps={moduleProps} loadingElement={loadingElement} />
  ));
};
